import axios from "axios";
import { requestInterceptors, responseInterceptors } from "api";

// notifications-api instance. Reuses the global auth + tenant interceptors
// from src/api so JWT, _subdomain, X-Organization-Id, and X-Acting-Org-Id
// behavior stays identical to flex2 and the other domain modules.
const notificationsBaseURL =
  process.env.REACT_APP_NOTIFICATIONS_API_URL || process.env.REACT_APP_API_URL;

const notificationsApiInstance = axios.create({
  baseURL: notificationsBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

notificationsApiInstance.interceptors.request.use(...requestInterceptors);

// Request interceptors are shared, but the RESPONSE ones deliberately are NOT.
//
// The global handler treats any 401 as "your session died": it clears
// localStorage and dispatches logoutUser(). That is right for flex2-api, which
// is the session authority — but catastrophic here. notifications-api is a
// secondary service that may be down, not deployed in this environment, or
// simply unable to resolve the caller, and the navbar bell polls it on EVERY
// page. Routing its 401s into the global handler logs the user straight out of
// the platform, which is exactly what happened.
//
// So: notifications-api can fail however it likes and the caller decides what
// to do. It can never end a session.
notificationsApiInstance.interceptors.response.use(
  (result) => result,
  (error) => {
    if (error?.response?.status === 401) {
      console.warn(
        "[notifications-api] 401 — not signing the user out; this service is not the session authority."
      );
    }
    return Promise.reject(error);
  }
);

export default notificationsApiInstance;
export { apiInstanceFileUpload, cachedApiInstance } from "api";
